import React from 'react';

import RecipesList from '../RecipesList';

const Recipes = () => (
  <RecipesList isMealPlannerView />
);

export default Recipes;
